import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const BitradeXAiBotPage = lazy(() => import('../pages/bitradex-ai-bot/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/bitradex-ai-bot',
    element: <BitradeXAiBotPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
